/**
 * Mapping of human readable version of ticket issuer to topdesk ticket issuer
 */
export default {
    "VEDUCON": "veducon",
    "API CGI": "cgi",
    "API GTT": "gtt"
}